import { jsx as p } from "react/jsx-runtime";
import c from "clsx";
import { createClassNameSelectors as s } from "../../utils/classNameSelectors.js";
import "../../utils/sectionPreview.js";
import "react";
function i(a, t = {}) {
  const { asMargin: e, negative: r } = t;
  return `${e ? "m" : ""}${{
    top: "t",
    right: "r",
    bottom: "b",
    left: "l"
  }[a]}${r ? "-n" : ""}`;
}
function f(a, t) {
  const { top: e, right: r, bottom: o, left: n } = a;
  return c(
    e ? s(i("top", t), e, "0") : null,
    r ? s(i("right", t), r, "0") : null,
    o ? s(i("bottom", t), o, "0") : null,
    n ? s(i("left", t), n, "0") : null
  );
}
function S(a) {
  return (t, e) => {
    const r = f(t, e), o = (n) => {
      const { className: l, ...m } = n;
      return /* @__PURE__ */ p(a, { ...m, className: c(l, r) });
    };
    return o.displayName = "WithSpace", o;
  };
}
export {
  f as createSpaceClassName,
  S as withSpace
};
